import { createApi } from '@reduxjs/toolkit/query/react'
import { handleError } from '../../commons/utils/utils'
import { setAnnouncementDetail } from '../slices/announcementSlice'
import { generateRPCQuery, getBaseQuery } from './apiUtils'
import apiConstants from './constants'

export const announcementApi = createApi({
  reducerPath: 'announcementApi',
  refetchOnFocus: false,
  baseQuery: getBaseQuery(),
  tagTypes: ['AnnouncementDetails', 'AllAnnouncements'],
  endpoints: (builder) => ({
    getNewFeatureDialogs: builder.query({
      query: (requestParams: AnnouncementParams) =>
        generateRPCQuery(
          apiConstants.ANNOUNCEMENTS_RPC_PATH,
          'getNewFeatureDialogs',
          requestParams
        ),
      providesTags: [{ type: 'AllAnnouncements' }]
    }),
    getAnnouncementDetails: builder.query({
      query: (requestParams: GetAnnouncementParams) =>
        generateRPCQuery(
          apiConstants.ANNOUNCEMENTS_RPC_PATH,
          'getNewFeatureDialog',
          requestParams
        ),
      providesTags: [{ type: 'AnnouncementDetails' }],
      async onQueryStarted ({}, { dispatch, queryFulfilled }) {
        try {
          const { data } = (await queryFulfilled) as {
            data?: GetAnnouncementDetailsResponse
          }
          if (data?.result) {
            dispatch(setAnnouncementDetail(data.result))
          }
        } catch (err: any) {
          handleError(err, dispatch)
        }
      }
    }),
    updateAnnouncementStatus: builder.mutation({
      query: (requestParams: UpdateAnnouncementStatusParams) =>
        generateRPCQuery(
          apiConstants.ANNOUNCEMENTS_RPC_PATH,
          'updateAnnouncementStatus',
          requestParams
        ),
      invalidatesTags: [{ type: 'AnnouncementDetails' }]
    }),
    validateAnnouncement: builder.mutation({
      query: (requestParams: AnnouncementValidationParams) =>
        generateRPCQuery(
          apiConstants.ANNOUNCEMENTS_RPC_PATH,
          'validateAnnouncement',
          requestParams
        )
    }),
    createNewFeatureDialog: builder.mutation({
      query: (requestParams: CreateAnnouncementParams) =>
        generateRPCQuery(
          apiConstants.ANNOUNCEMENTS_RPC_PATH,
          'createNewFeatureDialog',
          requestParams
        ),
      invalidatesTags: ['AllAnnouncements']
    }),
    editNewFeatureDialog: builder.mutation({
      query: (requestParams: EditAnnouncementParams) =>
        generateRPCQuery(
          apiConstants.ANNOUNCEMENTS_RPC_PATH,
          'editNewFeatureDialog',
          requestParams
        ),
      invalidatesTags: ['AllAnnouncements', 'AnnouncementDetails']
    })
  })
})

export const {
  useUpdateAnnouncementStatusMutation,
  useGetAnnouncementDetailsQuery,
  useGetNewFeatureDialogsQuery,
  useValidateAnnouncementMutation,
  useCreateNewFeatureDialogMutation,
  useEditNewFeatureDialogMutation
} = announcementApi
